'use strict';
/*

    To use this input widget adapter you need to register it with your
    adapter registry.

*/

import _objectSpread from "@babel/runtime/helpers/objectSpread";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { createComponentVNode, normalizeProps } from "inferno";
import { Component } from 'inferno';
import { Adapter } from 'component-registry';
import { interfaces } from 'isomorphic-schema';
import { IInputFieldWidget } from '../interfaces';
import classnames from 'classnames';
import { renderString } from './common';
import { generateId } from './utils';
import { DateField } from 'isomorphic-schema';
import { Input } from 'inferno-bootstrap';
import DateInput from './DateField';

function pad(inp) {
  if (inp === undefined) {
    return;
  } else if (inp.toString().length === 1) {
    return '0' + inp;
  } else {
    return inp;
  }
}

function isProperDateTime(inp) {
  return !isNaN(new Date(inp).getTime());
}

var InputWidget = /*#__PURE__*/function (_Component) {
  _inherits(InputWidget, _Component);

  function InputWidget(props) {
    var _this;

    _classCallCheck(this, InputWidget);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(InputWidget).call(this, props));

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "didGetDateInput", function (propName, value) {
      if (typeof value === 'string') {
        var tmpNew = value.split('-');
        value = _this.state.value || new Date();
        value.setFullYear(tmpNew[0]);
        value.setMonth(tmpNew[1] - 1);
        value.setDate(tmpNew[2]);
      }

      _this.setState({
        value: value,
        popoverOpen: _this.state.popoverOpen && isProperDateTime(value)
      });

      if (value === undefined || isProperDateTime(value)) {
        _this.props.onChange(_this.props.propName, value);
      }
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "didGetTimeInput", function (e) {
      e.preventDefault();
      var value = e.target.value;

      if (typeof value === 'string') {
        var tmpNew = value.split(/[^\d]/).map(function (n) {
          return parseInt(n);
        }); // Handle 12 hour clock https://www.timeanddate.com/time/am-and-pm.html

        if (value.indexOf('pm') > 0) {
          if (tmpNew[0] < 12) {
            tmpNew[0] += 12;
          }
        } else if (value.indexOf('am') > 0) {
          if (tmpNew[0] === 12 && tmpNew[1] > 0) {
            tmpNew[0] = 0;
          }
        }

        value = _this.state.value || new Date();
        value.setHours(tmpNew[0] || 0);
        value.setMinutes(tmpNew[1] || 0);
        value.setSeconds(tmpNew[2] || 0);
      }

      _this.setState({
        value: value,
        popoverOpen: _this.state.popoverOpen && isProperDateTime(value)
      });

      if (value === undefined || isProperDateTime(value)) {
        _this.props.onChange(_this.props.propName, value);
      }
    });

    _this.state = {
      value: props.value
    };
    return _this;
  }

  _createClass(InputWidget, [{
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      this.setState({
        value: nextProps.value
      }); // Todo: Update calendar
    }
  }, {
    key: "render",
    value: function render(_ref) {
      var inputName = _ref.inputName,
          namespace = _ref.namespace,
          options = _ref.options,
          doesNotRenderLabel = _ref.doesNotRenderLabel,
          id = _ref.id;
      var field = this.props.adapter.context;
      var isValid = this.props.validationError || this.props.invariantError ? false : undefined;
      var dateStr;

      if (this.state.value) {
        var val = this.state.value;
        dateStr = "".concat(val.getFullYear(), "-").concat(pad(val.getMonth() + 1), "-").concat(pad(val.getDate()));
      }

      var dateNamespace = namespace.slice();
      dateNamespace.push('_date');
      var dummyAdapter = {
        context: new DateField({
          placeholder: field.placeholder,
          readOnly: field.readOnly
        })
      };
      var ariaLabels = {
        'aria-invalid': isValid !== undefined,
        'aria-labelledby': doesNotRenderLabel ? undefined : id,
        'aria-label': doesNotRenderLabel ? renderString(field.label || 'inferno-formlib--DateTimeField', options && options.lang, 'DateTime Field') : undefined,
        'aria-required': field._isRequired ? field._isRequired : undefined
      };
      return createComponentVNode(2, DateInput, {
        "className": classnames('InfernoFormlib-DateTimeGroup', {
          'InfernoFormlib-DateTimeGroup--noValue': !this.state.value
        }),
        "innerClassName": "InfernoFormlib-DateTime_date",
        "adapter": dummyAdapter,
        "inputName": inputName + '_date',
        "namespace": dateNamespace,
        "valid": isValid,
        "value": dateStr,
        "id": id,
        "doesNotRenderLabel": doesNotRenderLabel,
        "onChange": this.didGetDateInput,
        children: normalizeProps(createComponentVNode(2, Input, _objectSpread({
          "className": "InfernoFormlib-DateTime_time",
          "id": generateId(this.props.namespace, '_time__Field'),
          "name": this.props.inputName + '_time',
          "valid": isValid,
          "placeholder": renderString('hh:mm:ss', options && options.lang),
          "readOnly": field.readOnly,
          "value": this.state.value && this.state.value.toLocaleTimeString()
        }, ariaLabels, {
          "onChange": this.didGetTimeInput
        })))
      });
    }
  }]);

  return InputWidget;
}(Component);

export default InputWidget;
new Adapter({
  implements: IInputFieldWidget,
  adapts: interfaces.IDateTimeField,
  Component: InputWidget
});